/* tslint:disable */

declare var Object: any;
export interface RemittanceReportSettingsInterface {
  "start_date": Date;
  "end_date": Date;
  "property_id": number;
  "invoice_tag": string;
  "unpaid_invoice_ids"?: Array<any>;
  "tenants_over_payments": number;
  "report_object"?: string;
  "id"?: number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt"?: Date;
}

export class RemittanceReportSettings implements RemittanceReportSettingsInterface {
  "start_date": Date;
  "end_date": Date;
  "property_id": number;
  "invoice_tag": string;
  "unpaid_invoice_ids": Array<any>;
  "tenants_over_payments": number;
  "report_object": string;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt": Date;
  constructor(data?: RemittanceReportSettingsInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `RemittanceReportSettings`.
   */
  public static getModelName() {
    return "RemittanceReportSettings";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of RemittanceReportSettings for dynamic purposes.
  **/
  public static factory(data: RemittanceReportSettingsInterface): RemittanceReportSettings{
    return new RemittanceReportSettings(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'RemittanceReportSettings',
      plural: 'RemittanceReportSettings',
      path: 'RemittanceReportSettings',
      idName: 'id',
      properties: {
        "start_date": {
          name: 'start_date',
          type: 'Date'
        },
        "end_date": {
          name: 'end_date',
          type: 'Date'
        },
        "property_id": {
          name: 'property_id',
          type: 'number'
        },
        "invoice_tag": {
          name: 'invoice_tag',
          type: 'string'
        },
        "unpaid_invoice_ids": {
          name: 'unpaid_invoice_ids',
          type: 'Array&lt;any&gt;'
        },
        "tenants_over_payments": {
          name: 'tenants_over_payments',
          type: 'number',
          default: 0
        },
        "report_object": {
          name: 'report_object',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "deletedAt": {
          name: 'deletedAt',
          type: 'Date',
          default: new Date(0)
        },
      },
      relations: {
      }
    }
  }
}
